/* Helpers puros do Kanban (sem estado). */

export const todayLocal = () => new Date().toLocaleDateString("en-CA");

export function overdueDays(o) {
  if (!o.exit_date || o.production_status === "enviado") return 0;
  const exit = o.exit_date.slice(0, 10);
  const today = todayLocal();
  if (exit >= today) return 0;
  return Math.round((new Date(today) - new Date(exit)) / 86400000);
}

// Dias desde a última movimentação de coluna (fallback: entrada no sistema)
export function daysStopped(o) {
  let last = o.last_moved_at || null;
  if (!last) {
    for (const h of o.history || []) {
      if (typeof h.action === "string" && h.action.startsWith("moved:")) last = h.at;
    }
  }
  const base = last || o.created_at || o.synced_at;
  if (!base) return 0;
  return Math.max(0, Math.floor((Date.now() - new Date(base).getTime()) / 86400000));
}

// Mais urgente primeiro: data limite mais próxima no topo (sem data vai para o fim)
export const urgencySort = (a, b) => {
  const da = (a.exit_date || "9999-12-31").slice(0, 10);
  const db = (b.exit_date || "9999-12-31").slice(0, 10);
  if (da !== db) return da.localeCompare(db);
  return String(a.bling_number || "").localeCompare(String(b.bling_number || ""), undefined, { numeric: true });
};

export function matchesAdvanced(o, f) {
  if (f.customer && !(o.customer || "").toLowerCase().includes(f.customer.toLowerCase())) return false;
  if (f.silk) {
    const silks = [o.silk_color, ...(o.order_items || []).map((it) => it.silk_color)]
      .filter(Boolean).map((s) => s.trim().toLowerCase());
    if (!silks.includes(f.silk.toLowerCase())) return false;
  }
  if (f.cupColor) {
    const colors = (o.order_items || []).flatMap((it) => (it.color_breakdown || []).map((cb) => (cb.color || "").trim().toLowerCase()));
    if (!colors.includes(f.cupColor.toLowerCase())) return false;
  }
  if (f.sku) {
    const skus = (o.order_items || []).map((it) => (it.sku || "").toLowerCase());
    if (!skus.some((s) => s.includes(f.sku.toLowerCase()))) return false;
  }
  if (f.overdueOnly && overdueDays(o) <= 0) return false;
  if (f.stoppedDays && daysStopped(o) <= parseInt(f.stoppedDays, 10)) return false;
  if (f.deadlineStart || f.deadlineEnd) {
    const d = (o.exit_date || "").slice(0, 10);
    if (!d) return false;
    if (f.deadlineStart && d < f.deadlineStart) return false;
    if (f.deadlineEnd && d > f.deadlineEnd) return false;
  }
  return true;
}

export function countActiveFilters(f) {
  return (
    (f.customer ? 1 : 0) + (f.silk ? 1 : 0) + (f.cupColor ? 1 : 0) +
    (f.sku ? 1 : 0) + (f.overdueOnly ? 1 : 0) + (f.stoppedDays ? 1 : 0) +
    (f.deadlineStart || f.deadlineEnd ? 1 : 0)
  );
}
